import { z } from "zod";
import { AbstractExtractSchema } from "./abstract/abstractExtract.entities";
import { HbIdSchema } from "../traits";

export enum ExtractBrandSchemaEnum {
	ExtractBrand = "ExtractBrand"
};

export const ExtractBrandSchema = AbstractExtractSchema
	.merge(HbIdSchema)
	.merge(z.object({
		"@id": z.string(), // "/api/extract_brands/1"
		"@type": z.string(), // "ExtractBrand"
		id: z.number(),	// 1
		actif: z.string(), // "1"
		libelle: z.string(), // "Brand 1"
	}))
	.describe(ExtractBrandSchemaEnum.ExtractBrand);

export type ExtractBrand = z.infer<typeof ExtractBrandSchema>;
